import { render, staticRenderFns } from "./ExhibitionView.vue?vue&type=template&id=545903a9&scoped=true&"
import script from "./ExhibitionView.vue?vue&type=script&lang=js&"
export * from "./ExhibitionView.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionView.vue?vue&type=style&index=0&id=545903a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545903a9",
  null
  
)

export default component.exports